import track from './track.js'
import { resolveTrackMeta } from './modules.js'
import { ensureConfiguredRoutes } from './trackConfig.js'

function enterIfTracked(to) {
  if (!to || !to.path) return
  const meta = resolveTrackMeta(to.path) || resolveTrackMeta(to.fullPath)
  if (!meta) return
  track.pageEnter({
    routePath: to.fullPath || to.path,
    moduleCode: meta.moduleCode,
    pageCode: meta.pageCode
  })
}

function sameRoute(a, b) {
  if (!a || !b) return false
  return (a.fullPath || a.path) === (b.fullPath || b.path)
}

/**
 * 安装路由埋点：配置表路由优先，离开前 beforeEach leave，关闭页 beforeunload
 * @param {import('vue-router').default} router
 */
export function installRouterHook(router) {
  if (!router) return

  let enterToken = 0

  function enterAfterConfig(to) {
    const token = ++enterToken
    ensureConfiguredRoutes().then(function () {
      if (token !== enterToken) return
      if (!sameRoute(router.currentRoute, to)) return
      enterIfTracked(to)
    })
  }

  router.beforeEach(function (to, from, next) {
    if (
      from &&
      from.path &&
      (resolveTrackMeta(from.path) || resolveTrackMeta(from.fullPath))
    ) {
      track.pageLeave()
    }
    next()
  })

  router.afterEach(function (to) {
    enterAfterConfig(to)
  })

  // 动态路由晚于首屏加载时：若落地页已在配置里，补一次 enter
  if (router.currentRoute && router.currentRoute.path) {
    enterAfterConfig(router.currentRoute)
  }

  // 菜单动态路由加载完成后，再按当前路由补一次 enter（避免首进白名单页漏记）
  if (router.onReady) {
    router.onReady(function () {
      if (router.currentRoute) {
        enterIfTracked(router.currentRoute)
      }
    })
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', function () {
      track.pageLeave()
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/track/routerHook.js